import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  header: {
    padding: theme.spacing(2, 4),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5, 3),
    },
  },
  headerIcon: {
    backgroundColor: props => (props.negative ? theme.palette.common.red100 : theme.palette.common.blue100),
    borderRadius: '50%',
    height: 40,
    marginRight: theme.spacing(2),
    width: 40,
  },
  title: {
    flex: 1,
    marginRight: 10,
  },
}));

export default useStyles;
